<template>
  <div v-if="show_ad" class="Ad">
    <i v-if="show_close" @click="closeAd();" class="close el-icon-close"></i>
    <a v-if="ad && image" :target="ad.target" :href="ad.href"><img :src="image.http_path"/></a>
  </div>
</template>
<script>
export default {
  data () {
    return {
      image:null,
      show_ad:true,
      ad:null
    }
  },
  props: ['show_close','position','path'],
  created () {
    this.get_ad();
    this.show_ad = sessionStorage[this.path+''+this.position] === undefined ? true:JSON.parse(sessionStorage[this.path+''+this.position]);
  },
  methods: {
    closeAd() {
      sessionStorage[this.path+''+this.position] = false;
      this.show_ad = false;
    },
    get_image() {
      let self = this;
      self.$http.post(self.$config.apibase + '/index.php/api/upload/get_image.html',{image_id:self.ad.image}).then(function(response){
        if(response.data.state == 0){
          self.image = response.data.image;
          self.close = false;
        }
      });
    },
    get_ad(){
      let self = this;
      self.$http.post(self.$config.apibase + '/index.php/api/ad/get_ad.html',{path:this.path || this.$route.path,position:this.position}).then(function(res){
        if(res.data.state != 0 || !res.data.ad){
          return;
        }
        self.ad = res.data.ad;
        self.get_image();
      });
    }
  }
}
</script>
<style scoped>
  .Ad{
    width:100%;
    overflow:hidden;
  }
  .Ad img{
    max-width:100%;
  }
  .close{
    position: relative;
    top: 31px;
    z-index: 999;
    float: right;
    right: 10px;
    opacity: 0.7;
    background-color: #fff;
    padding: 3px;
  }
</style>


// WEBPACK FOOTER //
// Ad.vue?63cec2b0